export default "__VITE_ASSET__LHPpRlhW__"